import { useGetSelectConversionTypesQuery } from "api/TenantSlug/ConversionType/hooks.ts";

export const useConversionTypeSelectOptions = (enabled = true) => {
    const { data, isLoading, error } = useGetSelectConversionTypesQuery({}, { enabled });

    const options =
        data?.conversionTypes?.map((type) => ({
            label: type.title,
            value: type.title,
        })) ?? [];

    return {
        options,
        loading: isLoading,
        error: error ? String(error) : null,
    };
};
